"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTracker = exports.eventTracker = exports.EventCategory = void 0;
const PublicConfig_1 = require("../Config/PublicConfig");
const RudderStack_1 = require("./Targets/RudderStack");
const GoogleAds_1 = require("./Targets/GoogleAds");
const Honeycomb_1 = require("./Targets/Honeycomb");
var Target_1 = require("./Target");
Object.defineProperty(exports, "EventCategory", { enumerable: true, get: function () { return Target_1.EventCategory; } });
let eventTrackerInstance;
function eventTracker() {
    if (!eventTrackerInstance) {
        eventTrackerInstance = new EventTracker();
        eventTrackerInstance.init();
    }
    return eventTrackerInstance;
}
exports.eventTracker = eventTracker;
class EventTracker {
    constructor() {
        this.allTargets = [];
        this.destinations = {
            defaultTargets: [],
            pageViewTargets: [],
            identifyTargets: [],
        };
        if (this.isActive()) {
            const rudderStack = new RudderStack_1.RudderStack();
            const googleAds = new GoogleAds_1.GoogleAds();
            const honeycombLogger = new Honeycomb_1.Honeycomb();
            if (typeof window !== "undefined") {
                // This is frontend
                /*
                const googleAnalytics = new GoogleAnalytics();
                this.destinations.defaultTargets.push(googleAnalytics);
                this.destinations.pageViewTargets.push(googleAnalytics);
                this.allTargets.push(googleAnalytics);
                */
                /* will be uncommented when we'll have a campain
                const facebookPixel = new FacebookPixel();
                this.destinations.defaultTargets.push(facebookPixel);
                this.allTargets.push(facebookPixel);
                */
                this.destinations.pageViewTargets.push(rudderStack);
                this.destinations.defaultTargets.push(googleAds);
                this.destinations.defaultTargets.push(honeycombLogger);
                this.allTargets.push(googleAds);
                this.allTargets.push(honeycombLogger);
            }
            else {
                // This is backend
                this.destinations.identifyTargets.push(rudderStack);
            }
            this.destinations.defaultTargets.push(rudderStack);
            this.allTargets.push(rudderStack);
            /*
            const mixpanel = new Mixpanel();
            this.destinations.defaultTargets.push(mixpanel);
            this.destinations.pageViewTargets.push(mixpanel);
            this.destinations.identifyTargets.push(mixpanel);
            this.allTargets.push(mixpanel);
            */
        }
        // this.destinations[TrackingEventName.HOMEPAGE_CRAWL_SUBMIT] = { targets: [ EventTrackingTargetType.GOOGLE_ANALYTICS ] }
    }
    isActive() {
        return ((0, PublicConfig_1.publicConfig)().stage.isProd ||
            (0, PublicConfig_1.publicConfig)().stage.isDevelop ||
            (0, PublicConfig_1.publicConfig)().stage.isLocal ||
            (0, PublicConfig_1.publicConfig)().stage.isBeta);
    }
    init() {
        this.allTargets.forEach((target) => {
            target.init();
        });
    }
    pageView(info) {
        if (this.isActive()) {
            this.destinations.pageViewTargets.forEach((target) => {
                target.pageView(info);
            });
        }
    }
    identify(user, group) {
        if (this.isActive()) {
            this.destinations.identifyTargets.forEach((target) => {
                target.identify(user, group);
            });
        }
    }
    track(eventInfo, isOrgEvent) {
        var _a;
        if (this.isActive()) {
            const targets = eventInfo.category in this.destinations
                ? (_a = this.destinations[eventInfo.category]) === null || _a === void 0 ? void 0 : _a.targets
                : this.destinations.defaultTargets;
            targets === null || targets === void 0 ? void 0 : targets.forEach((target) => {
                target.track(eventInfo, isOrgEvent);
            });
        }
    }
}
exports.EventTracker = EventTracker;
//# sourceMappingURL=index.js.map